import React, { useEffect, useState } from "react";
import Modal from "gp-modal";
import Services from "./services";

const ListaDependentes = ({ somenteVisualizacao, cpf, onSelecionar }) => {
  const [listaDependentes, setListaDependentes] = useState([]);

  useEffect(() => {
    Services.obterListaDependente(cpf)
      .then((response) => response.data)
      .then(setListaDependentes)
      .catch((e) => console.log(e));
  }, [cpf]);

  return (
    <>
      <div className="modal-body">
        <table className="table table-sm table-bordered table-align table-striped">
          <thead className="thead-light">
            <tr>
              <th className="text-center">Nome</th>
              <th className="text-center">Data Nascimento</th>
              <th className="text-center">Tipo Depedência </th>
              <th className="text-center">Status</th>
              <th className="text-center" width="10%" />
            </tr>
          </thead>
          <tbody>
            {listaDependentes.length > 0 ? (
              listaDependentes.map((item, index) => (
                <tr key={index}>
                  <td className="text-center">{item.nomeDependente}</td>
                  <td className="text-center">{item.dataNascimento}</td>
                  <td className="text-center">{item.tipoDependencia}</td>
                  <td className="text-center">{item.status}</td>
                  <td className="text-center">
                    {somenteVisualizacao ? (
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => onSelecionar(item.id)}
                      >
                        <i className="fas fa-eye" /> Visualizar
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => onSelecionar(item.id)}
                      >
                        <i className="fas fa-edit" /> Editar
                      </button>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="noResult text-center">
                  {" "}
                  Nenhum dependente encontrado
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ListaDependentes;
